import Change from './Change';

export default Change;
